// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Billing = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Billing = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Billing = _exports.Billing = function Billing(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M17.5 6.66699V7.70866H2.5V6.66699C2.5 5.00033 3.33333 4.16699 5 4.16699H15C16.6667 4.16699 17.5 5.00033 17.5 6.66699ZM17.5 8.95866V13.3337C17.5 15.0003 16.6667 15.8337 15 15.8337H5C3.33333 15.8337 2.5 15.0003 2.5 13.3337V8.95866H17.5ZM8.95833 12.5003C8.95833 12.1553 8.67833 11.8753 8.33333 11.8753H5.83333C5.48833 11.8753 5.20833 12.1553 5.20833 12.5003C5.20833 12.8453 5.48833 13.1253 5.83333 13.1253H8.33333C8.67833 13.1253 8.95833 12.8453 8.95833 12.5003Z",
      fill: "currentColor"
    }));
  };
});
